
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

import {HeadBar, CellRow, Stars, VideoPlayer} from '@/components';
import {HotelProxy} from '@/http/RequestProxy.class.js';
import EvaluationItem from './components/EvaluationItem';

const hotelProxy = new HotelProxy();

export default {
name: 'evaluation-list',
components: {
VideoPlayer,
HeadBar,
CellRow,
Stars,
PopupPicker,
EvaluationItem,
},
data(){
const lanType = +window.localStorage.getItem('lan_type');

return {
isShowPicker: false,    // 显示选择器

hotelId: '',
curPage: 1,
lanType: 1,

ratingData: {},   // 评分数据
evalListData: [], // 评价列表数据

pickerData: [[{name: this.$i18n.t('hotel.All'), value: '0'}, {name: '简体中文', value: '1'}, {name: '日本語', value: '2'}, {name: '繁體中文', value: '3'}, {name: 'ENGLISH', value: '4'}, {name: '한국', value: '5'}]],

currentSrc: '',   // 当前视频播放的视频地址
};
},
created(){
this.hotelId = this.$route.params.hotel_id;
this.getEvalList();
},
beforeDestroy(){
window.removeEventListener('scroll', this.loadDataWithPage);
},
methods: {
getEvalList(){
this.$vux.loading.show();
hotelProxy.getHotelEvaluationList({hotel_id: this.hotelId, page: this.curPage, lan_type: this.lanType, language: this.lanType, filter_lan_type: this.lanType})
.then(resp => {
if(resp){
this.ratingData = resp.data.rating_total;
this.evalListData.push(...resp.data.reviews.rows);

if(resp.data.reviews.count >= 20){  // 数据大于等于20条分页
this.loadDataWithPage();
}
}
this.$vux.loading.hide();
});
},

loadDataWithPage(){
window.addEventListener('scroll', () => {
const windScroll = document.body.scrollTop || document.documentElement.scrollTop,
docH = document.documentElement.offsetHeight,
clientH = window.clientHeight;

if(docH - windScroll >= clientH){
this.curPage++;
this.getEvalList();
}
}, false);
},

onChangeLanguage(data){
this.lanType = data[0];
this.evalListData = [];
this.getEvalList();
},

onShowLangPicker(){
this.isShowPicker = true;
},








/** 播放视频 */
onPlayNow(curUrl){
this.currentSrc = curUrl;
},

/** 关闭全屏播放器 */
onClosePlayer(){
this.currentSrc = '';
},
},
}



// WEBPACK FOOTER //
// ./src/views/evaluation/evaluation-list.vue